export const abbreviateNumber = (value: number | string, fixed = 0) => {
  const num = Number(value);

  if (num === -1234567890) {
    return 'N/A';
  }

  if (num === 0 || num < 1000) {
    return num.toFixed(0 + fixed);
  }

  const b = num.toPrecision(2).split('e');
  const k =
    b.length === 1 ? 0 : Math.floor(Math.min(Number(b[1].slice(1)), 14) / 3);
  /* eslint-disable no-restricted-properties */
  const c = Number(
    k < 1 ? num.toFixed(0 + fixed) : (num / 10 ** (k * 3)).toFixed(1 + fixed),
  );
  /* eslint-enable no-restricted-properties */
  const d = c < 0 ? c : Math.abs(c);

  return d + ['', 'K', 'M', 'B', 'T'][k];
};

export const getPercentage = (used: number, total: number) => {
  if (used > total) {
    return 100;
  }

  return Math.floor((used / total) * 100);
};

export const centsToDollars = (cents: number, round?: boolean): string => {
  return (cents / 100).toFixed(round ? 0 : 2).replace(/[.,]00$/, '');
};
